import Aura from "@primevue/themes/aura";
import ConfirmationService from "primevue/confirmationservice";
import PrimeVue from "primevue/config";
import ToastService from "primevue/toastservice";
import { createApp } from "vue";

import "primeicons/primeicons.css";
import "./styles.css";

import App from "./App.vue";
import { germanLocale } from "./locale";
import { router } from "./router";

createApp(App)
  .use(router)
  .use(PrimeVue, {
    // Aura, as it comes. The look is deliberately not designed yet.
    theme: {
      preset: Aura,
      options: {
        // Light, always. The default is "system", which emits an
        // @media (prefers-color-scheme: dark) block - a Windows machine set to
        // dark would hand the admin a colour scheme nobody chose. "none" stops
        // those rules being generated at all; a never-matching selector would
        // still ship them.
        darkModeSelector: "none",
      },
    },
    // Nothing here benefits from the click animation.
    ripple: false,
    locale: germanLocale,
  })
  .use(ToastService)
  .use(ConfirmationService)
  .mount("#app");
